import { useEffect, useState } from 'preact/hooks'
import { saveDispatcher } from '../utils.js'
import ActionCard from './ActionCard'
import Submit from './Submit.jsx'
import Footer from './Footer'
import Alert from './Alert.jsx'
import { clearLocalDataByPrefix, getIsStorageEnabled, setIsStorageActive } from '../services/storage.js'
import useForceUpdateOnResize from '../hooks/useForceUpdateOnResize.js'
import ProgressBar from './ProgressBar.jsx'
import useHorizontalSliderMethods from '../hooks/useHorizontalSliderMethods.js'
import { useAppContext } from '../contexts/AppContext.jsx'
import LastSlide from './LastSlide.jsx'
import { trackLastActiveSeparatorChanged } from '../services/trackService.js'

export function App() {
  const { playbookId, finalSlideLayout, viewMode, enableDocumentView, enableFunnelView, showScore } = useAppContext()
  const [status, setStatus] = useState({})
  const [showAlert, setShowAlert] = useState(false)
  const [blurred, setBlurred] = useState(false)
  const [isStorageEnabled, setIsStorageEnabled] = useState(true)
  const [isAcReady, setIsAcReady] = useState(false)
  const [progress, setProgress] = useState(0)

  useForceUpdateOnResize()

  useEffect(() => {
    saveDispatcher.saveCallback = (data, oldData) => {
      console.log('💾 Form data changed', data)
      trackLastActiveSeparatorChanged(playbookId, data, oldData)
      dispatchEvent(new CustomEvent('actioncard-change', { detail: data }))
    }
  }, [])

  useEffect(() => {
    if (status.text) {
      setShowAlert(true)
      if (status.type !== 'error') {
        const timer = setTimeout(() => {
          setShowAlert(false)
        }, 3000) // Hide non-error alert after 3 seconds
        return () => clearTimeout(timer)
      }
    }
  }, [status])

  useEffect(() => {
    window.addEventListener('beforeunload', e => {
      if (getIsStorageEnabled()) return

      clearLocalDataByPrefix(playbookId)
    })
  }, [])

  const handleBrowOpenClosed = isOpened => {
    const isLastSlide = window.AC_getStep?.()?.type === 'last'
    if (isLastSlide) return

    setBlurred(isOpened)
  }

  const handleStorageEnabling = isEnabled => {
    setIsStorageEnabled(isEnabled)
    setIsStorageActive(isEnabled)
  }

  const scrollContainer = useHorizontalSliderMethods(isAcReady)
  const isFunnelView = viewMode === 'funnel'

  return (
    <div
      className={`fixed inset-0 flex flex-col 
        ${enableDocumentView ? 'dark:bg-black' : 'dark:bg-[#1D1D1D]'} 
        ${enableFunnelView ? 'web_play_funnel_view' : ''} 
        ${enableDocumentView ? 'web_play_doc_view' : ''} 
        overflow-hidden
      `}
    >
      {isFunnelView && <ProgressBar progress={progress} />}
      <div
        ref={scrollContainer}
        className={`flex basis-auto grow-[1] overflow-hidden transition-[filter]
          ${blurred ? 'blur-[2px] brightness-75 dark:bg-transparent bg-white' : ''}
        `}
      >
        <ActionCard setIsAcReady={setIsAcReady} />
        {isFunnelView && (
          <LastSlide showScore={showScore} playbookId={playbookId} finalSlideLayout={finalSlideLayout} />
        )}
      </div>

      <Submit
        setStatus={setStatus}
        onOpenClose={handleBrowOpenClosed}
        isStorageEnabled={isStorageEnabled}
        setIsStorageEnabled={handleStorageEnabling}
        isAcReady={isAcReady}
        setProgress={setProgress}
      />

      <div className="z-10">
        <Footer />
      </div>

      <div
        className={`
          z-20
          transition-transform duration-500 ease-in-out 
          transform fixed bottom-0 left-0 right-0
          ${showAlert ? 'translate-y-0' : 'translate-y-full'} 
        `}
      >
        <Alert message={status.text} type={status.type} setShowAlert={setShowAlert} />
      </div>
    </div>
  )
}
